import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize } from 'cerialize';

export class OffPlatformReservationInfo {
  @autoserialize
  reservationId: number;

  @autoserialize
  organizationCode: string;

  @autoserialize
  riderName: string;

  @autoserialize
  pickupLocation: string;

  @autoserialize
  dropoffLocation: string;

  @autoserialize
  pickupDate: Date;

  @autoserialize
  distanceEstimate: number;

  @autoserialize
  durationEstimate: number;

  @autoserialize
  tripMileage: number;

  @autoserialize
  notes: string;

  @autoserialize
  pickUpArrivedTime: Date;

  @autoserialize
  dropOffArrivedTime: Date;

  static OnSerialized(instance: OffPlatformReservationInfo, json: any): void {
    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeInstant(instance.pickupDate);
    }

    if (!isNullOrUndefined(instance.pickUpArrivedTime)) {
      json.pickUpArrivedTime = DateUtil.serializeLocalTime(instance.pickUpArrivedTime);
    }

    if (!isNullOrUndefined(instance.dropOffArrivedTime)) {
      json.dropOffArrivedTime = DateUtil.serializeLocalTime(instance.dropOffArrivedTime);
    }
  }

  static OnDeserialized(instance: OffPlatformReservationInfo, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeInstant(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['pickUpArrivedTime'])) {
      instance.pickUpArrivedTime = DateUtil.deserializeLocalTime(json['pickUpArrivedTime']);
    }

    if (!isNullOrUndefined(json['dropOffArrivedTime'])) {
      instance.dropOffArrivedTime = DateUtil.deserializeLocalTime(json['dropOffArrivedTime']);
    }
  }
}
